<script>
import giftfinder from '~/mixins/giftfinder.vue'

export default {
  mixins: [giftfinder]
}
</script>
